import { DisabledTag } from '@nile/components';
import React from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { SVGIcon } from '@superops/super-icons';
import { Tooltip } from 'react-clone-tippy';
import { TextStyle } from '@shopify/polaris';

function FailureCell(props) {
  const { cell } = props;
  return (
    <>
      {cell?.value ? (
        <Tooltip title={cell?.value}>
          <div className="ml8 fx actr g10">
            <div className="mt4">
              <SVGIcon name="InlineError" size="sm" />
            </div>

            <div className="ellipsis">
              <TextStyle variation="subdued">{cell?.value}</TextStyle>
            </div>
          </div>
        </Tooltip>
      ) : (
        <DisabledTag>
          <FormattedMessage id="app.noData.message" />
        </DisabledTag>
      )}
    </>
  );
}

export default injectIntl(FailureCell);
